import Modal from '@hero/ui-kit/components/Modal';
import useComponentMargin from '@hero/ui-kit/hooks/useComponentMargin';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import Container from '@hero/ui-kit/layout/Container';
import Section from '@hero/ui-kit/layout/Section';
import P from '@hero/ui-kit/typography/P';
import React from 'react';
import { useUserStatusContext } from '../../../context/UserStatus';
import { ExternalUserListItem } from '../types';
import { getTupleValue } from '../utils';
import * as Style from './style.module.scss';
import { IAMListRole } from '../../IAM/types';
import UserDetails from './UserDetails';

const UserItem: React.FC<{ user: ExternalUserListItem; roles?: IAMListRole[] }> = ({
    user,
    roles
}) => {
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const { permissions } = useUserStatusContext();

    const userName = React.useMemo(() => {
        if (user?.first_name && user?.last_name) {
            return `${user.first_name} ${user.last_name}`;
        }
        return undefined;
    }, [user]);

    const smallMarginLeft = useComponentMargin({ marginLeft: 'small' });

    const handleOpenEditModal = React.useCallback(() => {
        permissions.iam.inviteUserView && setOpenEditModal(true);
    }, [permissions]);

    const handleCloseEditModal = React.useCallback(() => {
        setOpenEditModal(false);
    }, []);

    const status =
        user.invite_status === 'INVITE_EXPIRED' ? 'INVITE EXPIRED' : user?.invite_status || 'N/A';

    return (
        <Section noDefaultPadding>
            <ClickableOpacity
                fullWidth
                alt="Open edit modal"
                onClick={handleOpenEditModal}
                className={Style.rowBtn}
            >
                <Section padding="small" className={Style.userItem}>
                    <Container gridTemplateColumns={'3fr 1fr 1fr'}>
                        <div className={Style.nameWrapper}>
                            {userName ? (
                                <P noDefaultMargin strong>
                                    {userName}
                                </P>
                            ) : null}
                            <P noDefaultMargin styles={{ ...(userName && { ...smallMarginLeft }) }}>
                                {user?.email || 'N/A'}
                            </P>
                        </div>

                        <P strong noDefaultMargin>
                            {user?.role_value || getTupleValue(user?.role, 'name') || 'N/A'}
                        </P>

                        <P noDefaultMargin strong>
                            {status}
                        </P>
                    </Container>
                </Section>
            </ClickableOpacity>

            <Modal
                externalControls={[openEditModal, setOpenEditModal]}
                isCancelable
                styles={{ minWidth: '55rem', padding: 0 }}
            >
                <UserDetails
                    closeModal={handleCloseEditModal}
                    userName={userName || 'N/A'}
                    user={user}
                    roles={roles}
                />
            </Modal>
        </Section>
    );
};

export default UserItem;
